import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=08bbe203&scoped=true&"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js&"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrderModal.vue?vue&type=style&index=0&id=08bbe203&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbe203",
  null
  
)

export default component.exports